import { InjectionToken } from '@angular/core';
import { CategoriesApiProvider } from '../services/categories.service';
import { ClientApiProvider } from '../services/client.api';
import { GenderApiProvider } from '../services/gender.api';
import { NationalityApiProvider } from '../services/nationality.api';

export const GENDER_API = new InjectionToken<GenderApiProvider>('GenderApi');
export const CATEGORIES_API = new InjectionToken<CategoriesApiProvider>('CategoriesApi');
export const NATIONALITY_API = new InjectionToken<NationalityApiProvider>('NationalityApi');
export const CLIENT_API = new InjectionToken<ClientApiProvider>('ClientApi');
